import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { CircularProgress, Container } from '@mui/material';
import logo from '../Fxer.AI (7).png'; // Adjust the path to your image

const WelcomePage: React.FC = () => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const baseUrl = 'http://localhost:3000';
  //const baseUrl = 'https://fxer.network';


  useEffect(() => {
    ReactGA.event({
      category: 'User',
      action: 'sign_up',
      label: 'New User',
    });

    const checkSubscription = async () => {
      try {
        const token = await getAccessTokenSilently();
        const response = await fetch(`${baseUrl}/user/subscription`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();

        const searchParams = new URLSearchParams(location.search);
        const action = searchParams.get('action');

        if (!data.active) {
          // If the user is logging in (not a new sign-up), redirect to SubscriptionNeededPage
          if (action === 'login') {
            navigate('/subscription');
          } else {
            // New user logic
            const sessionResponse = await fetch(`${baseUrl}/user/subscription`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
              },
            });
            const sessionData = await sessionResponse.json();

            if (sessionData.url) {
              window.location.href = sessionData.url;
            } else {
              console.error('Failed to create subscription session:', sessionData.error);
              navigate('/subscription');
            }
          }
        } else {
          setTimeout(() => navigate('/'), 1000); // Delay before redirecting
        }
      } catch (error) {
        console.error('Error checking subscription status:', error);
        navigate('/error'); // Redirect to an error page if needed
      }
    };

    checkSubscription();
  }, [getAccessTokenSilently, navigate, location]);

  return (
    <Container component="main" maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8 }}>
      <h1>Welcome to Fxer.AI!</h1>
      <img src={logo} alt="FxerFox" style={{ width: '150px', marginBottom: '20px' }} />
      <p>You will be redirected to your dashboard shortly....</p>
      <CircularProgress sx={{ mt: 2 }} />
    </Container>
  );
};

export default WelcomePage;
